import { ContainerModule } from '@patsnap/tahiti-core/shared/inversify';
import { CronApi, CronApiImpl } from './apis/cron-api';

export const cronContainer = new ContainerModule((bind) => {
    bind<CronApi>(CronApi).to(CronApiImpl).inSingletonScope();
});

export * from './apis/cron-api';
export * from './types';
